'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function NotFound() {
    const router = useRouter();

    const handleGoHome = () => {
        router?.push('/');
    };

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <div className="relative min-h-screen flex flex-col items-center justify-center bg-app-gradient p-6 overflow-hidden">
            {/* Decorative background */}
            <div aria-hidden className="pointer-events-none absolute -top-32 -right-24 h-[28rem] w-[28rem] rounded-full bg-[hsl(var(--primary)/0.10)] blur-3xl" />
            <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-24 h-[28rem] w-[28rem] rounded-full bg-[hsl(var(--primary)/0.06)] blur-3xl" />

            <div className="relative text-center max-w-md animate-fade-up">
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <span className="block text-[10rem] leading-none font-800 text-gradient-cherry tracking-tight">
                            404
                        </span>
                        <div className="absolute inset-0 -z-10 blur-3xl bg-[hsl(var(--primary)/0.18)]" />
                    </div>
                </div>

                <h2 className="text-2xl font-800 text-[hsl(var(--foreground))] tracking-tight mb-2">Page Not Found</h2>
                <p className="text-[hsl(var(--muted-foreground))] mb-8">
                    The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get you back on track.
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={handleGoBack}
                        className="inline-flex items-center justify-center gap-2 px-5 h-11 rounded-xl border border-[hsl(var(--border))] bg-white text-[hsl(var(--foreground))] font-600 hover:bg-[hsl(var(--primary-tint))] hover:text-[hsl(var(--primary-dark))] hover:border-[hsl(var(--primary)/0.35)] active:scale-[0.98] transition-all duration-150"
                    >
                        <Icon name="ArrowLeftIcon" size={16} />
                        Go Back
                    </button>

                    <button
                        onClick={handleGoHome}
                        className="inline-flex items-center justify-center gap-2 px-5 h-11 rounded-xl bg-cherry-gradient text-white font-700 shadow-cherry hover:shadow-cherry-glow active:scale-[0.98] transition-all duration-200"
                    >
                        <Icon name="HomeIcon" size={16} variant="solid" />
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
